// @ts-nocheck
import { buttonStyles } from "@store/Themes/common/mixins/button";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { ButtonType, MobiusButtonType } from "@toolkit/Framework/Types/Button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { buttonGetHoverProps } from "@toolkit/Themes/common/props/button";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Button --------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const getButton = (color: string, hoverColor: string, type: ButtonType): ButtonPresentationProps => ({
    shape: "rounded",
    buttonType: type as MobiusButtonType,
    typographyProps: {
        weight: "inherit",
    },
    color,
    css: buttonStyles(type),
    ...buttonGetHoverProps(hoverColor),
});

const button: Styleguide["button"] = {
    primary: getButton("primary", "primary.alt", "solid"),
    secondary: getButton("secondary", "secondary.alt", "solid"),
    tertiary: getButton("text", "text.accent", "outline"), // The outline style is handle in Extensions/Mobius/Button/buttonType
};

export default button;
